<template>
  <div class="modalIngrBlock" ref="ingrBlock">
    <div v-if="hasDefaultIngredients" class="ingrHeader">
      {{
        $t(`edit.wishes`, {
          name: getTranslation(
            $store,
            "Product",
            "display_name",
            product.id,
            product.name
          )
        })
      }}
    </div>
    <default-ingredient-widget
      v-if="hasDefaultIngredients"
      :ingredients="defaultIngredientGroup.ingredients"
      @change.self="changeDefaultIngredientCount"
      ref="defaultIngredientWidgetRef"
    >
    </default-ingredient-widget>
    <div class="ingrGroupHeaderContainer" ref="ingrGroupHeaderContainer">
      <div
        class="ingrGroupHeaderContainerElement"
        :key="ingredient_group.id"
        v-for="(ingredient_group, index) in ingredientGroups"
      >
        <div
          v-html="ingredientGroupName(ingredient_group)"
          @click="setActiveGroupIdx(index)"
          v-if="ingredient_group.id !== -1"
          class="ingrGroupHeader text"
          :class="{
            visited: isVisited(index),
            active: isActive(index),
            'active-hasBackgroundImage': isActiveWithBackgroundImage(index),
            'circle-gradient': activeGroupIdx === index
          }"
        ></div>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="26px"
          viewBox="0 -960 960 960"
          width="26px"
          fill="var(--app_color_main)"
        >
          <path d="M472-480 288-664l88-88 272 272-272 272-88-88 184-184Z" />
        </svg>
      </div>
    </div>
    <div v-if="!hasDefaultIngredients" class="ingrHeader">
      {{
        $t(`edit.wishes`, {
          name: getTranslation(
            $store,
            "Product",
            "display_name",
            product.id,
            product.name
          )
        })
      }}
    </div>
    <div
      class="ingrGroupSubHeader"
      ref="ingrGroupSubHeader"
      v-if="
        ingredientGroups[activeGroupIdx] &&
          ingredientGroups[activeGroupIdx].information_text
      "
    >
      {{
        getTranslation(
          $store,
          "IngredientGroup",
          "information_text",
          ingredientGroups[activeGroupIdx].id,
          ingredientGroups[activeGroupIdx].information_text
        )
      }}
    </div>
    <div ref="ingrList" style="flex:1;overflow:hidden;">
      <ingredient-v2-widget
        ref="ingrV2Widget"
        :isEditIngredientLayer="isEditIngredientLayer"
        v-if="ingredientGroup && ingredientGroup.id !== -1"
        :ingredientgroup="ingredientGroup"
        @change.self="changeIngredientCount"
        @proceed="$emit('proceed')"
        @back="$emit('back')"
        @disableProceedByMinCount="disableProceedByMinCount"
        :height="ingv2height"
        :activeGroupIdx="activeGroupIdx"
        :disableProceed="disableProceed"
        :seenAllTabs="seenAllTabs"
        :isEdit="isEdit"
      ></ingredient-v2-widget>
    </div>
  </div>
</template>

<script>
import { getPopulatedIngredientGroups } from "@/utils/products";
import {
  cssVarValue,
  getTranslation,
  isBackgroundImageSet
} from "@/utils/helpers";
import DefaultIngredientWidget from "./defaultIngredientWidget";
import _, { isEmpty } from "lodash";
import IngredientV2Widget from "./ingredientV2Widget";

export default {
  name: "ingredientSelector",
  components: { IngredientV2Widget, DefaultIngredientWidget },
  computed: {
    ingredientGroups() {
      let igs = getPopulatedIngredientGroups(this.product);
      if (this.limited) {
        igs = igs.filter(ig => ig.offer_options_to_user);
      }
      return igs.filter(ig => ig.id !== -1);
    },
    ingredientGroup() {
      return this.ingredientGroups[this.activeGroupIdx];
    },
    defaultIngredientGroup() {
      let igs = getPopulatedIngredientGroups(this.product);
      let ig = igs.find(ig => ig.id === -1);
      if (isEmpty(ig)) {
        ig = { ingredients: [], id: -1, name: "default" };
      }
      return ig;
    }
  },
  created() {
    this.checkComposerPositionData();

    if (this.ingredientGroup) {
      this.$emit("tabChanged", this.ingredientGroup);
      this.$emit("ingredientSelectorState", this.ingredientSelectorState());
    }
    this.ingredientGroups.some((ig, index) => {
      this.activeGroupIdx = index;
      return true;
    });
    setTimeout(this.checkIngResize, 0);
  },
  data() {
    return {
      activeGroupIdx: 0,
      ingv2height: 800
    };
  },
  methods: {
    disableProceedByMinCount(disabled) {
      console.log(
        "ingredient selector disableProceedByMinCount disabled: " + disabled
      );
      this.$emit("disableProceedByMinCount", disabled);
    },
    isActive(index) {
      return this.activeGroupIdx === index;
    },
    isActiveWithBackgroundImage(index) {
      let bgSet = isBackgroundImageSet(
        "--component_ingredientSelector_ingrGroupHeader_active_background-image"
      );
      return this.activeGroupIdx === index && bgSet;
    },
    isVisited(index) {
      return index < this.activeGroupIdx;
    },
    setActiveGroupIdx(index) {
      console.log("setActiveGroupIdx: " + index);
      this.activeGroupIdx = index;
    },
    getTranslation,
    ingredientGroupName(ingredientgroup) {
      let name = ingredientgroup.name;
      if (ingredientgroup.display_name !== "")
        name = getTranslation(
          this.$store,
          "IngredientGroup",
          "display_name",
          ingredientgroup.id,
          ingredientgroup.display_name
        );
      let count = ingredientgroup.ingredients.reduce(
        (acc, ing) => acc + ing.count,
        0
      );
      let included_count = ingredientgroup.price_included_count;
      if (included_count > 0)
        return `${name}<span class="PriceIncludedCount">&nbsp;(${count}/${included_count})</span>`;
      return name;
    },
    changeIngredientCount({ group, ingredient, count }) {
      console.log("changeIngredientCount");
      this.$emit("change", { group, ingredient, count });
    },
    changeDefaultIngredientCount({ ingredient, count }) {
      let ingredient_group = this.defaultIngredientGroup;
      this.$emit("change", { group: ingredient_group, ingredient, count });
    },
    switchToId(ig_id) {
      let idx = this.ingredientGroups.findIndex(ig => ig.id === ig_id);
      if (idx !== -1) {
        this.activeGroupIdx = idx;
      }
    },
    /**
     * Calculates available space for ingredient-v2-widget
     * @returns {number}
     */
    calculateIngv2Height() {
      let topOfListWrapper = this.$refs.ingrV2Widget.$refs.ingredientListWrapper.getBoundingClientRect()
        .top;
      let TOTAL_HEIGHT = 1920;
      let BOTTOM_NAV_HEIGHT = 134;
      let ACTION_BUTTON_HEIGHT = 185;
      return (
        TOTAL_HEIGHT -
        BOTTOM_NAV_HEIGHT -
        ACTION_BUTTON_HEIGHT -
        topOfListWrapper
      );
    },
    updateIngredientV2Height() {
      if (!this.$refs.ingrV2Widget) return;
      if (this.isEdit && this.hasDefaultIngredients) {
        this.ingv2height = this.calculateIngv2Height();
        return;
      }
      const GAP = 20;
      const ADDITIONAL_MARGIN = 20;

      let itemBox_height = _.parseInt(
        cssVarValue("--component_ingredientV2Widget_itemBox_height")
      );
      let ingredientCount = this.$refs.ingrV2Widget.count;
      let linesCount = Math.ceil(ingredientCount / 4);
      if (linesCount <= 2) {
        this.ingv2height =
          linesCount * (itemBox_height + GAP) + ADDITIONAL_MARGIN;
        if (this.isEdit && this.activeItems && this.activeItems.length > 0) {
          const ADDITIONAL_MARGIN_EDIT_MODE = 160;
          this.ingv2height = itemBox_height + ADDITIONAL_MARGIN_EDIT_MODE;
        }
      } else {
        this.ingv2height = this.calculateIngv2Height();
      }
    },
    checkIngResize() {
      if (this.$refs.ingrBlock && this.$refs.ingrList) {
        let heightAsString = cssVarValue(
          "--component_ingredientV2Widget_height"
        );
        if (heightAsString) {
          let height = parseInt(heightAsString.replace(/\D/g, ""));
          this.ingv2height =
            height -
            this.defaultIngredientWidgetHeight() -
            this.ingredientGroupSubHeaderHeight();
        } else {
          this.updateIngredientV2Height();
        }
      }
    },
    defaultIngredientWidgetHeight() {
      let defaultIngredientWidgetHeight = 0;
      if (
        this.$refs.defaultIngredientWidgetRef &&
        this.$refs.defaultIngredientWidgetRef.$refs.defaultIngrList
      ) {
        defaultIngredientWidgetHeight = this.$refs.defaultIngredientWidgetRef.$refs.defaultIngrList.getBoundingClientRect()
          .height;
        console.log(
          "defaultIngredientWidgetHeight" + defaultIngredientWidgetHeight
        );
      }
      return defaultIngredientWidgetHeight;
    },
    ingredientGroupSubHeaderHeight() {
      let ingrGroupSubHeaderHeight = 0;
      if (this.$refs.ingrGroupSubHeader) {
        ingrGroupSubHeaderHeight = this.$refs.ingrGroupSubHeader.getBoundingClientRect()
          .height;
      }
      return ingrGroupSubHeaderHeight;
    },
    backAndConfirmButtonsHeight() {
      let backAndConfirmButtonsHeight = 0;
      if (this.$refs.ingrV2Widget.$refs.buttonContainer) {
        backAndConfirmButtonsHeight = this.$refs.ingrV2Widget.$refs.buttonContainer.getBoundingClientRect()
          .height;
      }
      return backAndConfirmButtonsHeight;
    },
    checkComposerPositionData: function() {
      if (
        this.ingredientGroups.filter(
          ig => ig["composer_position_data"].length > 0
        ).length > 0
      ) {
        this.$emit("composerPositionData", true);
      } else {
        this.$emit("composerPositionData", false);
      }
    },
    ingredientSelectorState() {
      return {
        activeGroupIdx: this.activeGroupIdx,
        ingredientGroupsLength: this.ingredientGroups.length,
        isFirstIngredientGroup: this.activeGroupIdx === 0,
        isLastIngredientGroup:
          this.activeGroupIdx === this.ingredientGroups.length - 1
      };
    }
  },
  props: {
    isEditIngredientLayer: {
      type: Boolean,
      default: false
    },
    activeItems: Array,
    hasDefaultIngredients: Boolean,
    disableProceed: Boolean,
    seenAllTabs: Boolean,
    product: Object,
    limited: Boolean,
    isEdit: Boolean
  },
  watch: {
    ingredientGroup(newVal, oldVal) {
      this.checkComposerPositionData();
      if (newVal) {
        this.$emit("tabChanged", newVal);
        this.$emit("ingredientSelectorState", this.ingredientSelectorState());
        if (oldVal.id !== newVal.id) {
          //TODO in editor mode div scrolls to top on changes
          // ???only fire events tabChanged + ingredientSelectorState if group uuid changes???
        }
      }
    },
    activeGroupIdx() {
      setTimeout(this.checkIngResize, 0);
    }
  }
};
</script>
<style lang="scss">
.PriceIncludedCount {
  display: var(--component_ingredientSelector_PriceIncludedCount_display);
}
</style>

<style lang="scss" scoped>
.modalIngrBlock {
  display: flex;
  flex-direction: column;
  background: var(--component_ingredientSelector_background);
  border-radius: var(
    --component_ingredientSelector_modalIngrBlock_border-radius
  );
  max-height: var(--component_ingredientSelector_modalIngrBlock_max-height);
  height: var(--component_ingredientSelector_modalIngrBlock_height);
  padding: var(--component_ingredientSelector_modalIngrBlock_padding);
  margin: var(--component_ingredientSelector_modalIngrBlock_margin);
}

.ingrHeader {
  color: var(--component_ingredientSelector_ingrHeader_color);
  display: var(--component_ingredientSelector_ingrHeader_display);
  font-family: var(--component_ingredientSelector_ingrHeader_font-family);
  font-size: var(--component_ingredientSelector_ingrHeader_font-size);
  text-align: center;
  text-transform: var(--component_ingredientSelector_ingrHeader_text-transform);
  margin-bottom: var(--component_ingredientSelector_ingrHeader_margin-bottom);
  margin-top: var(--component_ingredientSelector_ingrHeader_margin-top);
}

.ingrGroupHeaderContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: var(--component_ingredientSelector_ingrGroupHeaderContainer_padding);
}

.ingrGroupSubHeader {
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-family: var(
    --component_ingredientSelector_ingrGroupSubHeader_font-family
  );
  color: var(--component_ingredientSelector_ingrGroupSubHeader_color);
  font-size: var(--component_ingredientSelector_ingrGroupSubHeader_font-size);
  padding: var(--component_ingredientSelector_ingrGroupSubHeader_padding);
}

.ingrGroupHeader {
  font-family: var(--component_ingredientSelector_ingrGroupHeader_font-family);
  color: var(--component_ingredientSelector_ingrGroupHeader_color);
  background-color: var(
    --component_ingredientSelector_ingrGroupHeader_background-color
  );
  font-size: var(--component_ingredientSelector_ingrGroupHeader_font-size);
  padding: var(--component_ingredientSelector_ingrGroupHeader_padding);
  text-transform: var(
    --component_ingredientSelector_ingrGroupHeader_text-transform
  );
  text-align: center;
  margin-top: var(--component_ingredientSelector_ingrGroupHeader_margin-top);
  border-radius: 30px;

  &.active {
    color: var(--component_ingredientSelector_ingrGroupHeader_active_color);
    background: var(
      --component_ingredientSelector_ingrGroupHeader_active_background
    );
  }

  &.active-hasBackgroundImage {
    background-image: var(
      --component_ingredientSelector_ingrGroupHeader_active_background-image
    );
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: unset;
  }

  &.visited {
    color: var(--component_ingredientSelector_ingrGroupHeader_visited_color);
    background: var(
      --component_ingredientSelector_ingrGroupHeader_visited_background
    );
    background-image: var(
      --component_ingredientSelector_ingrGroupHeader_visited_background-image
    );
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 30px;
  }
}

.ingrGroupHeaderContainerElement {
  display: flex;
  align-items: center;

  svg {
    margin-inline: 10px;
  }

  &:last-child {
    svg {
      display: none;
    }
  }
}

.circle-gradient {
  background: var(--component_ingredientSelector_circle_gradient_background);
}
</style>
